module.exports = "<div class=\"ma-0 pa-0 r-header\">\n  <v-layout class=\"px-3\">\n    <v-layout column class=\"primary--text\">\n      <h2 style=\"font-weight: 500;\" v-text=\"$t('RECEPTION_DETAIL_TITLE')\"></h2>\n      <div class=\"r-header__underline\"></div>\n    </v-layout>\n  </v-layout>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/containers/mh-reception/components/mh-reception-detail-header/template.html
// module id = DK6n
// module chunks = 0